export function getEligibleGroupMembers(selectedGroup, myId) {
  const normalizedMyId = myId?.toString?.() ?? String(myId ?? '');

  return (selectedGroup?.members || [])
    .map((member) => {
      const userObj = member?.user || member;
      const rawId = userObj?._id || userObj?.id || userObj;
      const id = rawId?.toString?.() ?? String(rawId ?? '');
      if (!id || id === normalizedMyId) return null;

      return {
        id,
        username: userObj?.username || userObj?.name || 'Member',
        profileImage: userObj?.profileImage || null,
      };
    })
    .filter(Boolean);
}

export function buildGroupCallMemberIds(myId, selectedOtherIds) {
  const selfId = myId?.toString?.() ?? String(myId ?? '');
  const others = (selectedOtherIds || []).map((id) => id?.toString?.() ?? String(id));
  return [selfId, ...others.filter((id) => id && id !== selfId)];
}
